import React from 'react';
import { LandingTopWidget } from '../../organisms/landing';
import { SettingsWrapper } from '../../organisms/settings/SettingsWrapper';
import { SettingsAccessControl } from '../../organisms/settings/SettingsAccessControl';
import { DiscountsMain } from '../../organisms/settings/discounts/DiscountsMain';

/**
 * presentations/components/pages/settings/DiscountsPage.tsx
 */
const DiscountsPage: React.FC = () => {
  return (
    <SettingsAccessControl allowedRoles='creditViewer'>
      <div className='h-full flex flex-col bg-white'>
        <LandingTopWidget title='Settings' hideSearchBar hideUploadButton />
        <SettingsWrapper>
          <DiscountsMain />
        </SettingsWrapper>
      </div>
    </SettingsAccessControl>
  );
};

export default DiscountsPage;
